import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { AuthService } from '../../auth-common/auth/auth.service';
import { ChangeLog } from '../../interfaces/change-logs/change-logs';
import { PaginatedRepository } from '../../services/pagination/paginated.repository';
import { ToastrService } from "ngx-toastr";
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';

@Injectable({
    providedIn: 'root'
})
export class ChangeLogsRepositoryService extends PaginatedRepository<ChangeLog> {
    protected override _baseLink: string;

    constructor(
        http: HttpClient,
        messageService: ToastrService,
        @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
        super(
            http,
            messageService);

        this._baseLink = `${this.config.rootUrl}/Logs/Changes`;
    }

    private generateHeaders = () => {
        return {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        }
    }
}